import { render, staticRenderFns } from "./orderReports.vue?vue&type=template&id=b93c55b4&scoped=true"
import script from "./orderReports.vue?vue&type=script&lang=js"
export * from "./orderReports.vue?vue&type=script&lang=js"
import style0 from "./orderReports.vue?vue&type=style&index=0&id=b93c55b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93c55b4",
  null
  
)

export default component.exports